import React, { useState, useEffect }  from 'react';
import {Box} from "@mui/material";
import { Link } from "@mui/material";
import { Sling as Hamburger } from 'hamburger-react'
import "./Menu.css"
import logoImg from "../../../images/bubble-logo.png"
import avatarImg from "../../../images/avatar.png"
import { ButtonSubmitGreen } from '../Buttons/Buttons';
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setUser } from '../../../redux/states';
import { isIOSStandalonePWA } from '../../../utils/client-functions';
import NavButtonStyled from "../../../styled/NavButtons";
import ThemeToggle from "../Theme/ThemeToggle";
import ProfileIcon from "../ProfileIcon/ProfileIcon";
import Logo from "../Logo/Logo";
import styled from "styled-components";
import {useTheme} from "../Theme/ThemeContext"
import Button from "../Buttons/Button";
import NotificationBell from "../NotificationBell/NotificationBell";
import featureTutorial from "../Learn/data";
import Dropdown from "../Dropdown/Dropdown";
import useNotifications from '../../../hooks/useNotifications';
import { formatRelativeTime } from '../../../utils/dates';
import { ButtonThin } from "../Buttons/Buttons";
import AuthHeader from "../AuthHeader/AuthHeader";
import AuthSideMenu from "../AuthSideMenu/AuthSideMenu";

    const Nav = styled.nav`
    background: ${({theme})=> theme === 'dark' ? '#0C1E28' : '#fff'};
    `
    const StateLinks = styled.div`
        display: flex;
        gap: 1rem;
    `

    // Removed unused Popup styled component

    const DesktopHeadLinks = styled.div`
        color: ${({theme})=> theme === 'dark' ? '#fff' : '#000'};
        cursor: pointer;
    `;


    const screenWidth = window.innerWidth


    /* FOR LARGER SCREENS KTT SIGNAL */
    const MenuBarLarge = ({profileImg, unreadCount = 0, notifications = [], onMarkAllRead, onMarkOneRead}) => {
        const location = useLocation();
        const navigate = useNavigate()
        const isAuth = localStorage?.getItem("token");
        const dispatch = useDispatch()
        const {themeName} = useTheme();
        const [popupOpen, setPopupOpen] = useState(false);
        const [featureLearn, setFeatureLearn] = useState(false);


        useEffect(() => {
            if (popupOpen) {
                const timeoutId = setTimeout(() => {
                    setPopupOpen(false);
                }, 5000);

                return () => clearTimeout(timeoutId);
            }
        }, [popupOpen]);

        useEffect(() => {
            if (featureLearn) {
                const timeoutId = setTimeout(() => {
                    setFeatureLearn(false);
                }, 5000);

                return () => clearTimeout(timeoutId);
            }
        }, [featureLearn]);

        const handleLogout = async () => {
            if (isAuth) {
                navigate('/popin')
                localStorage?.removeItem('token')
                dispatch(setUser({}))
            }
        }

        return (

            <Nav theme={themeName} className="BigMenu">
                <div>
                    <Link href='/'>
                        <img src={logoImg} alt='Bubble Ai' className="Logo" />
                    </Link>
                </div>

                <div>
                    <div className='MenuItems'>

                        <Dropdown
                            trigger={
                                <DesktopHeadLinks theme={themeName}>
                                    How I Work
                                </DesktopHeadLinks>
                            }
                            items={featureTutorial.map((feature) => ({
                                label: (
                                    <Button
                                        secondary={true}
                                        width="100%"
                                        title={feature.title}
                                        link={`/how-i-work/${feature.slug}`}
                                    />
                                ),
                                value: feature.slug,
                            }))}
                        />

                        <Link href='/#pricing' className="ListItem">
                            <DesktopHeadLinks theme={themeName}>Pricing</DesktopHeadLinks>
                        </Link>
                        <ThemeToggle/>
                        <StateLinks>
                            {location.pathname === "/popin" ? <ButtonSubmitGreen><a href="/join-bubble" className="regLoginLink">Register</a></ButtonSubmitGreen>
                            : location.pathname === "/join-bubble" ? <ButtonSubmitGreen><a href="/popin" className="regLoginLink">Login</a></ButtonSubmitGreen>
                            : isAuth ?
                                    <>
                                        <NavButtonStyled>
                                            <Dropdown
                                                trigger={<NotificationBell number={unreadCount} />}
                                                menuClassName="BubblePopIn"
                                                items={[
                                                    { value: '__header', className: 'dropdown-header', label: (<div>Notifications</div>) },
                                                    ...notifications.map(n => {
                                                        const preview = (n.description || '').trim();
                                                        const short = preview.length > 60 ? preview.slice(0, 60) + '…' : preview;
                                                        return ({
                                                            value: n._id,
                                                            className: 'notification-item',
                                                            label: (
                                                                    <a href={n.url || '/'} onClick={() => onMarkOneRead?.(n._id)} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column' }}>
                                                                    <span className="notification-title" style={{ fontWeight: n.status === 'unread' ? 700 : 500 }}>{n.title}</span>
                                                                    {short && <span className="notification-body">{short}</span>}
                                                                    <span className="notification-meta" style={{ alignSelf: 'flex-end' }}>{formatRelativeTime(n.createdAt)}</span>
                                                                </a>
                                                            )
                                                        })
                                                    }),
                                                    ...(notifications.length > 0 ? [{
                                                        value: '__footer', className: 'dropdown-footer',
                                                        label: (
                                                            <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                                                                <ButtonThin border={`1px solid #6FCBD1`} color={'#0B1A21'} width={'100%'} height={'30px'} onClick={() => navigate('/user/dashboard/notifications')}>
                                                                    Show all
                                                                </ButtonThin>
                                                                <ButtonThin border={`1px solid #EE7B1C`} bgColor={'transparent'} color={themeName === 'dark' ? '#fff' : '#0B1A21'} width={'100%'} height={'30px'} onClick={onMarkAllRead}>
                                                                    Mark all read
                                                                </ButtonThin>
                                                            </div>
                                                        )
                                                    }] : [])
                                                ]}
                                            />
                                            <div className="profile">
                                                <Dropdown
                                                    menuClassName="BubblePopIn"
                                                    trigger={
                                                        <ProfileIcon profileImg={profileImg} />
                                                    }
                                                    forceDark={true}
                                                    items={[
                                                        {
                                                            label: (
                                                                <Button
                                                                    secondary={true}
                                                                    width="100%"
                                                                    title="Profile"
                                                                    link="/user/dashboard/profile"
                                                                />
                                                            ),
                                                            value: "profile",
                                                        },
                                                        {
                                                            label: (
                                                                <Button
                                                                    secondary={true}
                                                                    width="100%"
                                                                    title="Logout"
                                                                    clickHandle={handleLogout}
                                                                />
                                                            ),
                                                            value: "logout",
                                                        },
                                                    ]}
                                                />
                                            </div>
                                        </NavButtonStyled>


                                    </>

                                    : <ButtonSubmitGreen><a href="/join-bubble" className="regLoginLink">Login/Register</a></ButtonSubmitGreen>}
                        </StateLinks>
                    </div>
                </div>

            </Nav>

        )
    }

/* FOR SMALLER SCREENS KTT SIGNAL */
    const MenuBarSmall = ({profileImg, unreadCount = 0, notifications = [], onMarkAllRead, onMarkOneRead}) => {
        const location = useLocation()
        const [menuOpen, setMenuOpen] = useState(false)
        const navigate = useNavigate()
        const isAuth = localStorage?.getItem("token");
        const dispatch = useDispatch()
        const {themeName} = useTheme();


        const [popupOpen, setPopupOpen] = useState(false);

        useEffect(() => {
            if (popupOpen) {
                const timeoutId = setTimeout(() => {
                    setPopupOpen(false);
                }, 5000);

                return () => clearTimeout(timeoutId);
            }
        }, [popupOpen]);




        useEffect(() => {
            const getMenuElements = () => ({
                overlay: document.getElementById('overlay'),
                nav1: document.getElementById('nav-1'),
                nav2: document.getElementById('nav-2'),
                nav3: document.getElementById('nav-3'),
                nav4: document.getElementById('nav-4'),
                nav5: document.getElementById('nav-5'),
                smallMenuContainer: document.getElementById('small-menu-top'),
            });

            function toggleNav(menuOpen) {
                const {
                    overlay,
                    nav1,
                    nav2,
                    nav3,
                    nav4,
                    nav5,
                    smallMenuContainer,
                } = getMenuElements();

                if (!overlay || !nav1 || !nav2 || !nav3 || !nav4 || !nav5 || !smallMenuContainer) return;

                if (menuOpen) {
                    smallMenuContainer.classList.add('small-menu-out');
                    overlay.classList.remove('overlay-slide-left');
                    overlay.classList.add('overlay-slide-right');
                    nav1.classList.remove('slide-out-1');
                    nav1.classList.add('slide-in-1');
                    nav2.classList.remove('slide-out-2');
                    nav2.classList.add('slide-in-2');
                    nav3.classList.remove('slide-out-3');
                    nav3.classList.add('slide-in-3');
                    nav4.classList.remove('slide-out-4');
                    nav4.classList.add('slide-in-4');
                    nav5.classList.remove('slide-out-5');
                    nav5.classList.add('slide-in-5');
                } else {
                    smallMenuContainer.classList.remove('small-menu-out');
                    overlay.classList.remove('overlay-slide-right');
                    overlay.classList.add('overlay-slide-left');
                    nav1.classList.remove('slide-in-1');
                    nav1.classList.add('slide-out-1');
                    nav2.classList.remove('slide-in-2');
                    nav2.classList.add('slide-out-2');
                    nav3.classList.remove('slide-in-3');
                    nav3.classList.add('slide-out-3');
                    nav4.classList.remove('slide-in-4');
                    nav4.classList.add('slide-out-4');
                    nav5.classList.remove('slide-in-5');
                    nav5.classList.add('slide-out-5');
                }
            }
            
            toggleNav(menuOpen);
        }, [menuOpen]);

        const handleLogout = async () => {
            if (isAuth) {
                navigate('/popin')
                localStorage?.removeItem('token')
                dispatch(setUser({}))
            }
        }


        return (
            <Box>
                <div style={{marginTop: isIOSStandalonePWA() ? "50px" : "auto"}}>
                    <div id="small-menu-top"
                         className={isIOSStandalonePWA() ? 'IosContainer' : 'SmallMenuContainer'}
                         style={{background: themeName === "dark" ? '#0C1E28': '#fff' }}
                    >

                        <Logo link="/" />


                        <div className="NavButtons">

                            <NavButtonStyled>
                                {isAuth && (
                                    <Dropdown
                                        trigger={<NotificationBell number={unreadCount} />}
                                        menuClassName="BubblePopIn"
                                        items={[
                                            { value: '__header', className: 'dropdown-header', label: (<div>Notifications</div>) },
                                            ...notifications.map(n => {
                                                const preview = (n.description || '').trim();
                                                const short = preview.length > 60 ? preview.slice(0, 60) + '…' : preview;
                                                return ({
                                                    value: n._id,
                                                    className: 'notification-item',
                                                    label: (
                                                        <a href={n.url || '/'} onClick={() => onMarkOneRead?.(n._id)} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column' }}>
                                                            <span className="notification-title" style={{ fontWeight: n.status === 'unread' ? 700 : 500 }}>{n.title}</span>
                                                            {short && <span className="notification-body">{short}</span>}
                                                            <span className="notification-meta" style={{ alignSelf: 'flex-end' }}>{formatRelativeTime(n.createdAt)}</span>
                                                        </a>
                                                    )
                                                })
                                            }),
                                            ...(notifications.length > 0 ? [{
                                                value: '__footer', className: 'dropdown-footer',
                                                label: (
                                                    <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                                                        <ButtonThin border={`1px solid #6FCBD1`} color={'#0B1A21'} width={'100%'} height={'30px'} onClick={() => navigate('/user/dashboard/notifications')}>
                                                            Show all
                                                        </ButtonThin>
                                                        <ButtonThin border={`1px solid #EE7B1C`} bgColor={'transparent'} color={themeName === 'dark' ? '#fff' : '#0B1A21'} width={'100%'} height={'30px'} onClick={onMarkAllRead}>
                                                            Mark all read
                                                        </ButtonThin>
                                                    </div>
                                                )
                                            }] : [])
                                        ]}
                                    />
                                )}

                                <ThemeToggle/>
                                {isAuth &&
                                    <Dropdown
                                        trigger={
                                            <ProfileIcon profileImg={profileImg} />
                                        }
                                        menuClassName="BubblePopIn"
                                        forceDark={true}
                                        items={[
                                            {
                                                label: (
                                                    <Button
                                                        secondary={true}
                                                        width="100%"
                                                        title="Profile"
                                                        link="/user/dashboard/profile"
                                                    />
                                                ),
                                                value: "profile",
                                            },
                                            {
                                                label: (
                                                    <Button
                                                        secondary={true}
                                                        width="100%"
                                                        title="Logout"
                                                        clickHandle={handleLogout}
                                                    />
                                                ),
                                                value: "logout",
                                            },
                                        ]}
                                    />
                                }
                            </NavButtonStyled>



                            <div className='HamburgerContainer'>
                                <Hamburger
                                    color="#6FCBD1"
                                    rounded
                                    size={30}
                                    distance="md"
                                    toggled={menuOpen}
                                    toggle={setMenuOpen}
                                />
                            </div>

                        </div>

                    </div>

                </div>

                {/* MENU BLOCK */}

                <div className="overlay" id="overlay">

                    <nav style={{paddingTop: '60px'}}>
                        <ul>
                            {location.pathname === "/popin" ? <li id="nav-1"><a href="/join-bubble">Register</a></li>
                                : location.pathname === "/join-bubble" ? <li id="nav-1"><a href="/popin">Login</a></li>
                                : isAuth ? <li id="nav-1" className='logout' onClick={handleLogout}>Logout</li> : <li id="nav-1" onClick={()=>navigate('/join-bubble')}><a href="/join-bubble">Login/Register</a></li>}
                            <li id="nav-2" onClick={() => {
                                    window.scrollTo(0, document.getElementById('pricing').offsetTop);
                                    setMenuOpen(false);
                                }}
                            ><a href="/#pricing">Pricing</a></li>
                            <li id="nav-3"><a href="/how-i-work">How I Work</a></li>
                            <li id="nav-4"><a href="/support">Support</a></li>
                            <li id="nav-5"><a href="/privacy">Terms</a></li>
                        </ul>
                    </nav>
                </div>

            </Box>

        )
    }



    const HeaderHeightSetter = () => {
        useEffect(() => {
            const setHeaderHeightCSSVar = () => {
                try {
                    const root = document.documentElement;
                    const w = window.innerWidth;
                    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
                    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
                    const smallHeader = document.getElementById('small-menu-top');
                    const bigMenu = document.querySelector('.BigMenu');
                    let h = 60;
                    if (w > 900 && bigMenu) {
                        const cs = getComputedStyle(bigMenu);
                        h = parseInt(cs.height, 10) || 60;
                    } else if (smallHeader) {
                        const cs = getComputedStyle(smallHeader);
                        h = parseInt(cs.height, 10) || (isIOS && standalone ? 90 : 60);
                    } else if (isIOS && standalone) {
                        h = 90;
                    }
                    root.style.setProperty('--app-header-h', `${h}px`);
                } catch (e) {
                    // noop
                }
            };
            setHeaderHeightCSSVar();
            const onResize = () => setHeaderHeightCSSVar();
            window.addEventListener('resize', onResize);
            return () => window.removeEventListener('resize', onResize);
        }, []);
        return null;
    };

    const MenuBar = () => {
        const { profileImg } = useSelector((state) => state.stateData);
        const { unreadCount, preview: notifications, markAllRead: handleMarkAllRead, markOneRead } = useNotifications({ limit: 50 });
        const isAuth = localStorage?.getItem("token");
        const [authMenuOpen, setAuthMenuOpen] = useState(false);

        return (
            <>
                <HeaderHeightSetter />
                {screenWidth > 900 ? (
                    <MenuBarLarge profileImg={profileImg || avatarImg} unreadCount={unreadCount} notifications={notifications} onMarkAllRead={handleMarkAllRead} onMarkOneRead={markOneRead} />
                ) : isAuth ? (
                    <>
                        <AuthHeader authMenuOpen={authMenuOpen} onClick={() => setAuthMenuOpen(!authMenuOpen)} />
                        <AuthSideMenu opened={authMenuOpen} arrayDetails={[]} onSwitch={() => setAuthMenuOpen(false)} />
                    </>
                ) : (
                    <MenuBarSmall profileImg={profileImg || avatarImg} unreadCount={unreadCount} notifications={notifications} onMarkAllRead={handleMarkAllRead} onMarkOneRead={markOneRead} />
                )}
            </>
        );
    }

export default MenuBar;
